import { Controller } from "@hotwired/stimulus";

import { debounceController } from "../src/stimulus/debounce";

export default class AutoSubmittableController extends Controller<HTMLFormElement> {
  static debounces = ["save"];
  static targets = ["form"];
  declare readonly formTarget: HTMLFormElement;
  declare readonly formTargets: HTMLFormElement[];

  declare readonly hasFormTarget: boolean;

  connect(): void {
    debounceController(this);
  }

  save(): void {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    } else {
      this.element.requestSubmit();
    }
  }
}
